export const rules = function(self) {
  console.log(self)
  return {
    // 折扣
    customerRebate: [{
      required: true,
      message: '请输入折扣',
      trigger: ['change', 'blur'],
    }],
  }
}
 
export default {}